




































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import moment from "moment";
import { ContaPagarValidacaoContabilModel } from "@/models/contabil/contas-pagar/ContaPagarValidacaoContabilModel";
import MessageDialog from "@/components/modal/MessageDialog.vue";
import ContabilContaPagarService from "@/service/ContabilContaPagarService";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    MessageDialog,
    GsModalDialog,
  },
})
export default class ValidacaoContabil extends Vue {
  $refs!: {
    validacaoObserver: InstanceType<typeof ValidationObserver>;
    refuseReasonObserver: InstanceType<typeof ValidationObserver>;
  };

  contasPagar = [] as ContaPagarValidacaoContabilModel[];

  listaStatus = [
    { name: undefined, descricao: "Todas" },
    { name: "PENDENTE", descricao: "Pendente" },
    { name: "APROVADA", descricao: "Aprovada" },
    { name: "ENVIADA_PAGAMENTO", descricao: "Enviada Pagamento" },
    { name: "REPROVADA", descricao: "Reprovada" },
  ];

  // CONFIRM MODAL
  showConfirmModal = false;
  confirmTitle = "";
  confirmMessage = "";

// STATUS MODAL
  dialogType = "";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  nfToRefuse: number = 0;
  refuseReason: string = '';
  nfreprovada:string = '';
  tipoDeServico:string = '';
  
  mounted() {
    this.listarContasPagar();
  }

  filtroValidacaoContabil = {
    inicio: undefined,
    fim: undefined,
    today: moment().format("YYYY-MM-DD"),
    status: {
      name: undefined,
      descricao: "Todas",
    },
  };

  cabecalho = [
    {
      text: "Data Upload",
      value: "dataCriacao",
      width: "5%",
      align: "center",
      divider: true,
    },
    {
      text: "CPF / CNPJ",
      value: "cpfCnpj",
      width: "15%",
      align: "center",
      divider: true,
    },
    {
      text: "Inscrição municipal",
      value: "inscricaoMunicipal",
      divider: true,
    },
    { text: "Número NF", value: "numeroNF", divider: true },
    { text: "Valor bruto", value: "valorBruto", divider: true },
    { text: "Valor liquido", value: "valorLiquido", divider: true },
    { text: "Imposto", value: "totalImpostos", divider: true },
    {
      text: "Desconto inc.",
      value: "descontoIncondicional",
      divider: true,
    },
    { text: "Base cálculo", value: "baseCalculo", divider: true },

    { text: "Pedágio cliente", value: "pedagioCliente", divider: true },
    { text: "Pedágio prestador", value: "pedagioPrestador", divider: true },

    { text: "Status", value: "status", width: "5%", divider: true },

    {
      text: "Pedágio",
      value: "downloadPedagio",
      sortable: false,
      width: "5%",
      align: "center",
      divider: true,
    },

    {
      text: "NF",
      value: "download",
      sortable: false,
      width: "5%",
      align: "center",
      divider: true,
    },
    {
      text: "Ações",
      value: "actions",
      sortable: false,
      width: "8%",
      divider: true,
    },
  ];

  loading: boolean = false;

  listarContasPagar() {
    ContabilContaPagarService.listarContasPagar().then((res) => {
      this.contasPagar = res;
    });
  }

  acaoDialog() {
    this.showDialog = false;
  }

  filtrarValidacaoContabil() {
    this.$refs.validacaoObserver.validate().then((valid: boolean) => {
      if (valid) {
        ContabilContaPagarService.filtrar(this.filtroValidacaoContabil).then(
          (res) => {
            this.contasPagar = res.data;
          }
        );
      } else {
         setTimeout(() => {
          const errors = Object.entries(this.$refs.validacaoObserver.errors)
            .map(([key, value]) => ({ key, value }))
            .filter((error) => error["value"].length);
          this.$refs.validacaoObserver.refs[
            errors[0]["key"]
          ].$el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 100);

      }
    });
  }

  validar(idContaPagar: number, item: ContaPagarValidacaoContabilModel) {
    ContabilContaPagarService.atualizarStatusParaAprovada(idContaPagar)
    .then(
      (res) => {
        this.filtrarPorStatus();
        this.aprovarNF(item)

      }
    )
    .catch((err) => this.openDialog('error', 'Erro', 'Falha ao validar NF. Por favor, entre em contato com o suporte.'));
  }

  filtrarPorStatus() {
    ContabilContaPagarService.filtrarContasPagarPorStatus(
      this.filtroValidacaoContabil.status
    ).then((res) => {
      this.contasPagar = res.data;
    });
  }

  reprovar(idContaPagar: number, refuseReason: string, nfreprovada: string, tipoDeServico:string) {
    ContabilContaPagarService.atualizarStatusParaReprovada(idContaPagar, refuseReason)
    .then(
      (res) => {
        this.filtrarPorStatus();
        if(nfreprovada != undefined)
        this.reprovarNF(nfreprovada, tipoDeServico, refuseReason)
      }
    )
    .catch((err) => this.openDialog('error', 'Erro', 'Falha ao recusar NF. Por favor, entre em contato com o suporte.'));
  }

  downloadNotaFiscal(nomeArquivo: string) {
    ContabilContaPagarService.downloadNotaFiscal(nomeArquivo)
      .then((res) => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data]));
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `nota-fiscal_${moment().format("DD-MM-YYYY")}.pdf`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
      })
      .catch((err) => {
          this.openDialog('error', 'Erro', 'Não há arquivo de nota fiscal para download.');
      });
  }

  downloadPedagio(idContaPagar: number) {
    ContabilContaPagarService.downloadPedagio(idContaPagar)
      .then((res) => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/zip' }));
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `pedagios_${idContaPagar}_${moment().format("DD-MM-YYYY")}.zip`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
      })
      .catch((err) => {
          this.openDialog('error', 'Erro', 'Não há arquivo de pedágio para download.');
      });
  }
    
  gerarRelatorio() {
    this.$refs.validacaoObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        ContabilContaPagarService.gerarRelatorio(this.filtroValidacaoContabil).then(res => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'relatorio_conta_pagar.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loading = false;

        }).catch(err => {
          this.openDialog('error', 'Erro', err.message);
          this.loading = false;
        });
      }
        
    });    
  }

  gerarRelatorioExcel() {
    this.$refs.validacaoObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        ContabilContaPagarService.gerarRelatorioExcel(this.filtroValidacaoContabil).then(res => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'relatorio_conta_pagar.xls');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loading = false;

        }).catch(err => {
          this.openDialog('error', 'Erro', err.message);
          this.loading = false;
        });
      }
    });    
  }

  public openConfirmModal(
    title: string,
    message: string,
    nfToRefuse: number,
    item: ContaPagarValidacaoContabilModel,
    
  ): void {
    this.confirmTitle = title;
    this.confirmMessage = message;
    this.nfToRefuse = nfToRefuse;
    this.showConfirmModal = true;
    this.nfreprovada = item.numeroNF;
    this.tipoDeServico = item.tipoDeServico
    
  }

  public confirmModalOnClose(yes: boolean): void {
    if (!yes) {
      this.showConfirmModal = false;
    } else {
        this.$refs.refuseReasonObserver.validate().then((valid) => {
            if (valid && !!this.nfToRefuse) {
                this.reprovar(this.nfToRefuse, this.refuseReason, this.nfreprovada, this.tipoDeServico);
                this.nfToRefuse = 0;
                this.refuseReason = '';
                this.showConfirmModal = false;
            }
        });
    }
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
aprovarNF(item: ContaPagarValidacaoContabilModel){
        var notaFiscal = item.numeroNF
        var status = item.status
        if(item.tipoDeServico === 'SERVICOS_SAUDE'){
            ContabilContaPagarService.atualizarStatusNFParaAprovadaSaude(notaFiscal, )
        }else{
            ContabilContaPagarService.atualizarStatusNFParaAprovadaAssitencia(notaFiscal, )
        }
    }

    reprovarNF(notaFiscal:string, tipoDeServico:string, motivoRecusa: string){
        if(tipoDeServico === 'SERVICOS_SAUDE'){
            ContabilContaPagarService.atualizarStatusNFParaReprovadaSaude(notaFiscal, motivoRecusa).then(res =>{
                console.log(res)
            })
        }else{
            ContabilContaPagarService.atualizarStatusNFParaReprovadaAssintencia(notaFiscal, motivoRecusa)
        }
    }
}
